module.exports = __webpack_public_path__ + "media/images/trafficapp-logo-cc595b6e.png";